import {useAppSelector} from "@/store";
import {TutorState} from "@/store/slices/tutor";

export const useTutorStore = (): TutorState => {
    return useAppSelector(state => state.tutor)
}
